/* eslint-disable */
import { put, takeEvery } from "redux-saga/effects";
import UserEvents from "./UserEvents";
import UserApi from "./UserApi";
import { UserData, UserList } from "./User";
import {
    UpdateUserProfileImage,
    UpdateUserProfileImageComplete,
    GetUserInfoListComplete,
    UpdateUserInfo,
    UpdateUserInfoComplete,
    UpdateUserInfoFailed,
    LoginStarted,
    LoginComplete,
    GetSkillList,
    GetSkillListComplete,
    StartSyncBatchComplete,
    StartSyncBatchFailed,
    UpdateUserProfileImageFailed,
    AuthnComplete,
    AuthnStart,
    AuthStarted,
    ValidateTokenStarted,
    ValidateTokenSuccess,
    ValidateTokenFailure
} from "./UserActions";

function* AuthnWorker({ email, mttms }: ReturnType<typeof AuthnStart>) {
    const userInfo: UserData = yield UserApi.Authn(email, mttms);
    console.log("AuthnWorker:", userInfo)
    localStorage.setItem("user", userInfo.email)
    yield put(AuthnComplete(userInfo));
}

function* Auth(userAuth: ReturnType<typeof AuthStarted>) {
    console.log("UserSaga: Auth:", userAuth);

    const userInfo: UserData = yield UserApi.Auth(userAuth.userAuth.email, userAuth.userAuth.password);
    console.log("AuthnWorker:", userInfo);

    (window as any).email = userInfo.email;
    localStorage.setItem("user", userInfo.email)
    yield put(AuthnComplete(userInfo));
}
function* Login({ email }: ReturnType<typeof LoginStarted>) {
    const userInfo: UserData = yield UserApi.GetUser(email);
    console.log("UserSaga: Login", userInfo)
    yield put(LoginComplete(userInfo));
}

function* SignOutWorker() {
    const response: any = yield UserApi.SignOut();
    console.log("signout:", response)
}

// ユーザー一覧取得（管理画面用）
function* GetUserInfoList() {
    const listItems: UserList[] = yield UserApi.GetUserInfoList();
    yield put(GetUserInfoListComplete(listItems));
    console.log("GetUserInfoList", listItems);
}

// ユーザー一覧更新（管理画面用）
function* UpdateUserInfoWorker({ updateListItems }: ReturnType<typeof UpdateUserInfo>) {
    const listItems: any = yield UserApi.UpdateUserInfo(updateListItems);
    console.log("UserSaga: UpdateUserInfoWorker:", listItems)
    if (listItems.response && listItems.response.status !== 200) {
        yield put(UpdateUserInfoFailed());
        console.log("UpdateUserInfoFailed");
    }
    else {
        yield put(UpdateUserInfoComplete(listItems));
        console.log("UpdateUserInfo", listItems);
    }
}

function* UpdateProfileImage({ imageFile, profileItems }: ReturnType<typeof UpdateUserProfileImage>) {
    const user: any = yield UserApi.UpdateUserImage(imageFile, profileItems);
    console.log("UserUpdateFinished: ", user)
    if (user.response && user.response.status !== 200) {
        yield put(UpdateUserProfileImageFailed())
    } else {
        yield put(UpdateUserProfileImageComplete(user))
    }
}
// スキル取得・検索
function* GetSkillListWorker({ inputSkillList }: ReturnType<typeof GetSkillList>) {
    const outputSkillList: string[] = yield UserApi.GetSkillList(inputSkillList);
    yield put(GetSkillListComplete(outputSkillList));
    console.log("GetSkillList", outputSkillList);
}

// スキル取得・検索
function* StartSyncBatchWorker() {
    const response: any = yield UserApi.StartSyncBatch();
    console.log("UserSaga: StartSyncBatchWorker:", response)
    if (response.response && response.response.status !== 200) {
        yield put(StartSyncBatchFailed(response.stack))
    } else {
        yield put(StartSyncBatchComplete())
    }
}

/**
 * SSO登録
 * @param token トークン 
 * @returns 登録情報
 */
function* Office365Login( { accessToken, userLogin }: ReturnType<typeof ValidateTokenStarted>) {
    const response: any = yield UserApi.verifyToken(accessToken, userLogin);
    if (response.response && response.response.status !== 200) {
        yield put(ValidateTokenFailure(response.stack))
        return;
    }
    const userInfo: UserData = response;
    if (!userInfo.email) {
        yield put(ValidateTokenFailure("❌ Office365Login Tokenの検証失敗しました。"))
        return;
    }
    console.log("✅ Office365Login バックエンド検証成功", userInfo);
    localStorage.setItem("user", userInfo.email)
    yield put(ValidateTokenSuccess(userInfo))
}


export default function* UserSaga() {
    yield takeEvery(UserEvents.AuthnStart, AuthnWorker);
    yield takeEvery(UserEvents.AuthStart, Auth);
    yield takeEvery(UserEvents.GetUserInfoListStarted, GetUserInfoList);
    yield takeEvery(UserEvents.UpdateUserInfoStarted, UpdateUserInfoWorker);
    yield takeEvery(UserEvents.LoginStarted, Login);
    yield takeEvery(UserEvents.SignOut, SignOutWorker);
    yield takeEvery(UserEvents.UpdateUserProfileImageStarted, UpdateProfileImage);
    yield takeEvery(UserEvents.GetSkillListStarted, GetSkillListWorker);
    yield takeEvery(UserEvents.StartSyncBatch, StartSyncBatchWorker);
    yield takeEvery(UserEvents.ValidateSSOTokenStarted, Office365Login);
}
